const config = {
  "api": {
    "baseURL": "https://api-guiabranding.brasal.com.br",
    "token": "jwtToken"
  }
};

export default config;



// WEBPACK FOOTER //
// ./src/lib/config.js